import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compose class names, with later Tailwind utilities beating earlier ones.
 *
 * `cn('px-3 py-2', 'px-6')` -> `'py-2 px-6'`. Every component takes a `className`
 * and merges it through here, so a caller can always override a default without
 * fighting specificity.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
